import React, { createContext, useState, useEffect, useContext } from "react";
import api from "../../services/api";
import useWhatsApps from "../../hooks/useWhatsApps";
import WavoipWidget from "../../components/WavoipWidget";
import { AuthContext } from "../Auth/AuthContext";
import usePlans from "../../hooks/usePlans";

const WhatsAppsContext = createContext();
const isProd = process.env.NODE_ENV === "production";

const WhatsAppsProvider = ({ children }) => {
  // Add fallback values to prevent destructuring errors
  const whatsAppData = useWhatsApps();
  const { loading = false, whatsApps = [] } = whatsAppData || {};
  const { user } = useContext(AuthContext);
  const { getPlanCompany } = usePlans();
  
  const [wavoipToken, setWavoipToken] = useState(null);
  const [loadingSession, setLoadingSession] = useState(true);
  const [error, setError] = useState(null);
  const [canUseWavoip, setCanUseWavoip] = useState(false);

  // Verificar se o plano permite usar Wavoip
  useEffect(() => {
    const checkPlan = async () => {
      try {
        const planConfigs = await getPlanCompany(undefined, user?.companyId);
        const hasWavoipPermission = planConfigs?.plan?.wavoip === true;
        
        if (!isProd) {
          console.log('🔐 [WAVOIP] Verificação de plano:', {
            hasPermission: hasWavoipPermission,
            plan: planConfigs?.plan
          });
        }
        
        setCanUseWavoip(hasWavoipPermission);
      } catch (err) {
        if (!isProd) {
          console.error("Erro ao verificar plano Wavoip:", err);
        }
        setCanUseWavoip(false);
      }
    };
    
    if (user?.companyId) {
      checkPlan();
    }
  }, [user?.companyId, getPlanCompany]);

  useEffect(() => {
    const fetchSession = async () => {
      try {
        const { data } = await api.get("/call/historical/user/whatsapp");

        // let wavoipToken  = "";
        // for(const d of data){
        //   if(d?.wavoip){
        //     wavoipToken = d.wavoip;
        //     break;
        //   }
        // }
        if (!isProd) {
          console.log('wavoip token recebido:', data?.whatsapp?.wavoip ? '***' : null);
        }
        setWavoipToken(data?.whatsapp?.wavoip || null);
      } catch (err) {
        if (!isProd) {
          console.error("Erro fetchSession:", err);
        }
        setWavoipToken(null);
      } finally {
        setLoadingSession(false);
      }
    };
    fetchSession();
  }, []);


  // Log error state for debugging
  if (error) {
    if (!isProd) {
      console.warn("WhatsAppsProvider error:", error);
    }
  }

  return (
    <WhatsAppsContext.Provider value={{ whatsApps, loading, error }}>
      {children}
      {canUseWavoip && wavoipToken && (
        <WavoipWidget
          token={wavoipToken}
          onCallStart={(data) => {
            if (!isProd) {
              console.log("Chamada iniciada:", data);
            }
          }}
          onCallEnd={(data) => {
            if (!isProd) {
              console.log("Chamada finalizada:", data);
            }
          }}
          onError={(error) => {
            if (!isProd) {
              console.error("Erro wavoip:", error);
            }
          }}
        />
      )}
    </WhatsAppsContext.Provider>
  );
};

export { WhatsAppsContext, WhatsAppsProvider };